// extracted by css-extract-rspack-plugin
export default {"bui-Checkbox":"hJtmqCNU8SMp97Lu","bui-CheckboxIndicator":"AsCZ8LTTAs5lRnNR"};